(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  function initAll() {
    document.querySelectorAll('[data-team-section]').forEach(initSection);
  }

  function initSection(sectionEl) {
    const sectionId = sectionEl.getAttribute('data-section-id');
    const dataEl = sectionEl.querySelector('[data-team-json]');
    if (!dataEl) return;

    let TEAM = {};
    try { TEAM = JSON.parse(dataEl.textContent || '{}'); } catch (e) { console.warn('Invalid team JSON'); }

    const modal = sectionEl.querySelector('#team-modal-' + sectionId);
    const titleEl = modal.querySelector('#team-modal-title-' + sectionId);
    const roleEl = modal.querySelector('#team-modal-role-' + sectionId);
    const credEl = modal.querySelector('#team-modal-cred-' + sectionId);
    const bioEl = modal.querySelector('#team-modal-desc-' + sectionId);
    const photoEl = modal.querySelector('#team-modal-photo-' + sectionId);
    const socialEl = modal.querySelector('#team-modal-social-' + sectionId);
    const closeBtn = modal.querySelector('[data-close="button"]');
    const overlay = modal.querySelector('[data-close="overlay"]');

    let lastFocused = null;
    let requestId = 0; // only latest image load wins

    function createFocusTrap(container) {
      const FOCUSABLE = [
        'a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])',
        'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex="-1"])'
      ];
      return function trap(e) {
        if (e.key !== 'Tab') return;
        const nodes = Array.from(container.querySelectorAll(FOCUSABLE.join(','))).filter(el => el.offsetParent !== null);
        if (!nodes.length) return;
        const first = nodes[0];
        const last = nodes[nodes.length - 1];
        const active = document.activeElement;
        if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
      };
    }
    const trap = createFocusTrap(modal);

    function isBlankHTML(html) {
      if (!html) return true;
      const text = String(html).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
      return text.length === 0;
    }

    function fillModalText(data) {
      titleEl.textContent = data.name || '';
      roleEl.innerHTML = data.role || '';

      if (credEl) {
        credEl.innerHTML = data.credentials || '';
        credEl.style.display = isBlankHTML(data.credentials) ? 'none' : '';
      }

      bioEl.innerHTML = data.bio || '';

      socialEl.innerHTML = '';
      if (data.social && typeof data.social === 'object') {
        Object.entries(data.social).forEach(([label, url]) => {
          if (!url) return;
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = url; a.target = '_blank'; a.rel = 'noopener'; a.textContent = label;
          li.appendChild(a); socialEl.appendChild(li);
        });
      }
    }

    function setPhotoSafely(url, alt) {
      const myReq = ++requestId;
      // Clear immediately so previous photo never flashes
      photoEl.removeAttribute('src');
      photoEl.alt = '';
      modal.classList.add('is-loading');

      if (!url) { modal.classList.remove('is-loading'); return; }

      const img = new Image();
      img.src = url;

      const show = () => {
        // only apply if still the latest request
        if (myReq !== requestId) return;
        photoEl.src = url;
        photoEl.alt = alt || '';
        modal.classList.remove('is-loading');
      };

      if (img.decode) {
        img.decode().then(show).catch(show);
      } else if (img.complete) {
        show();
      } else {
        img.onload = show;
        img.onerror = show; // fail gracefully
      }
    }

    function openModal(id) {
      const data = TEAM[id];
      if (!data) { console.warn('Unknown team id:', id); return; }
      if (!data.bio) { console.warn('No bio content for:', id); return; }

      fillModalText(data);
      setPhotoSafely(data.photo, data.photoAlt || (data.name ? 'Portrait of ' + data.name : 'Portrait'));

      lastFocused = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tm-lock');
      document.body.classList.add('tm-lock');
      closeBtn.focus();
      document.addEventListener('keydown', onKeydown, true);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tm-lock');
      document.body.classList.remove('tm-lock');
      document.removeEventListener('keydown', onKeydown, true);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
      trap(e);
    }

    sectionEl.addEventListener('click', function (e) {
      const trigger = e.target.closest('.TeamBioName, .TeamBioBtn, .TeamBioLink, a[href^="#bio-"]');
      if (!trigger || !sectionEl.contains(trigger)) return;
      const id = trigger.getAttribute('data-team-id') || (trigger.getAttribute('href') || '').replace('#bio-', '');
      if (!id) return;
      e.preventDefault();
      openModal(id);
    });

    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);

    (function tryDeepLink() {
      const params = new URLSearchParams(window.location.search);
      const candidate = params.get('member');
      if (candidate && TEAM[candidate] && TEAM[candidate].bio) openModal(candidate);
    })();
  }
})();